"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VAULT_SETUP_NOT_CONFIGURED = void 0;
/** The vault setup of a deployment with no VaultFactory configured. */
exports.VAULT_SETUP_NOT_CONFIGURED = {
    configured: false,
    chainId: null,
    vaultFactory: null,
    fundFactory: null,
    implementationRegistry: null,
    latestRelease: null,
    stablecoins: [],
    fundContracts: null,
    fundCreate: null,
    fundCountry: null,
};
//# sourceMappingURL=IVaultSetup.js.map